import { Controller } from "@hotwired/stimulus";
import GoogleMap from "../../entrypoints/google_map/GoogleMap";

// Connects to data-controller="site-builder--google-maps"
export default class extends Controller {
  static values = {
    markerPayload: Array,
    zoom: String,
    gmapsApiKey: String,
    widgetId: String,
  };

  connect() {
    new GoogleMap(
      this.markerPayloadValue,
      this.zoomValue,
      this.widgetIdValue
    );
  }
}
